require('./liquidationTable.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const classNames = require('classnames');
const { formatAmount, formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ commons
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const { LabelDate } = require('commonsComponents/labelDate');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @ components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @ constants
const { PERCENTAGE_SYMBOL, LIQUIDATION_TABLE_MAX_ROWS_PER_VIEW } = require('constants/index');
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');

class LiquidationTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            maxRowsToSee: LIQUIDATION_TABLE_MAX_ROWS_PER_VIEW
        };

        this.buildColumnsTable = this.buildColumnsTable.bind(this);
        this.buildContentTable = this.buildContentTable.bind(this);
        this.handleViewMoreButtonClick = this.handleViewMoreButtonClick.bind(this);
    }

    buildColumnsTable() {
        return (
            <thead>
                <OKTableRow asHeader={true}>
                    <OKTableCell asHeader={true} />
                    <OKTableCell className="liquidation-table__interests" asHeader={true} colSpan={2}>
                        <FormattedText value="liquidation-interestsHave" />
                    </OKTableCell>
                    <OKTableCell className="liquidation-table__interests" asHeader={true} colSpan={2}>
                        <FormattedText value="liquidation-interestsFinancial" />
                    </OKTableCell>
                    <OKTableCell asHeader={true} />
                </OKTableRow>
                <OKTableRow asHeader={true}>
                    <OKTableCell className="liquidation-table__date" asHeader={true}>
                        <FormattedText value="liquidation-date" />
                    </OKTableCell>
                    <OKTableCell className="liquidation-table__type" asHeader={true}>
                        <FormattedText value="liquidation-type" />
                    </OKTableCell>
                    <OKTableCell className="liquidation-table__amount" asHeader={true}>
                        <FormattedText value="liquidation-amount" />
                    </OKTableCell>
                    <OKTableCell className="liquidation-table__type" asHeader={true}>
                        <FormattedText value="liquidation-type" />
                    </OKTableCell>
                    <OKTableCell className="liquidation-table__amount" asHeader={true}>
                        <FormattedText value="liquidation-amount" />
                    </OKTableCell>
                    <OKTableCell className="liquidation-table__total" asHeader={true}>
                        <FormattedText value="liquidation-total" />
                    </OKTableCell>
                </OKTableRow>
            </thead>
        );
    }

    buildContentTable() {
        const { immLiquidations } = this.props;
        const immLiquidationsByOder = immLiquidations.get('byOrder');
        const language = getLanguage();

        return immLiquidationsByOder.map((immLiquidationId, id) => {
            if (id + 1 <= this.state.maxRowsToSee) {
                const immLiquidation = immLiquidations.getIn(['byId', immLiquidationId]);
                const dateSeparator = " - ";
                const period = (
                    <div>
                        <LabelDate
                            date={immLiquidation.get('periodFromDate')}
                            language={language}
                            today={LABEL_DATE_TODAY}
                            yesterday={LABEL_DATE_YESTERDAY}
                        />
                        {dateSeparator}
                        <LabelDate
                            date={immLiquidation.get('periodToDate')}
                            language={language}
                            today={LABEL_DATE_TODAY}
                            yesterday={LABEL_DATE_YESTERDAY}
                        />
                    </div>
                );
                
                const immCreditInterest = immLiquidation.get('creditInterest');
                const immTaxRetention = immLiquidation.get('taxRetention');
                const plainAmountLiquidationObject = getPlainAmountObject(immLiquidation.get('payment'));
                let creditInterestType = null
                let taxRetentionType = null
                let plainAmountCreditObject = null
                let plainAmountTaxObject= null

                if (immCreditInterest) {
                    creditInterestType = `${formatAmount(immCreditInterest.get('type'))} ${PERCENTAGE_SYMBOL}`;
                    plainAmountCreditObject = getPlainAmountObject(immCreditInterest.get('payment'));
                }
                if (immTaxRetention) {
                    taxRetentionType = `${formatAmount(immTaxRetention.get('type'))} ${PERCENTAGE_SYMBOL}`;
                    plainAmountTaxObject = getPlainAmountObject(immTaxRetention.get('payment'));
                }
                return (
                    <OKTableRow key={id}>
                        <OKTableCell className="liquidation-table__date">
                            {period}
                        </OKTableCell>
                        <OKTableCell className="liquidation-table__type">
                            <span className="liquidation-table__type__value">
                                {creditInterestType}
                            </span>
                        </OKTableCell>
                        <OKTableCell className="liquidation-table__amount">
                            {plainAmountCreditObject && (
                                <OneLineSymbolAmount
                                    amountObject={plainAmountCreditObject}
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(plainAmountCreditObject, true)} />
                            )}
                        </OKTableCell>
                        <OKTableCell className="liquidation-table__type">
                            <span className="liquidation-table__type__value">
                                {taxRetentionType}
                            </span>
                        </OKTableCell>
                        <OKTableCell className="liquidation-table__amount">
                            {plainAmountTaxObject && (
                                <OneLineSymbolAmount
                                    amountObject={plainAmountTaxObject}
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(plainAmountTaxObject, true)} />
                            )}
                        </OKTableCell>
                        <OKTableCell className="liquidation-table__total">
                            <span className="liquidation-table__total__value">
                                <OneLineSymbolAmount
                                    amountObject={plainAmountLiquidationObject}
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(plainAmountLiquidationObject, true)} />
                            </span>
                        </OKTableCell>
                    </OKTableRow>
                );
            }
        });
    }

    handleViewMoreButtonClick() {
        const { immLiquidations } = this.props;
        const immLiquidationsByOder = immLiquidations.get('byOrder');
        const sizeLiquidation = immLiquidationsByOder.size;

        if (sizeLiquidation > this.state.maxRowsToSee) {
            this.setState(
                (prevState) => (
                    { maxRowsToSee: (prevState.maxRowsToSee + LIQUIDATION_TABLE_MAX_ROWS_PER_VIEW) }
                )
            )
        }
    }

    render() {
        const columnsTable = this.buildColumnsTable();
        const contentTable = this.buildContentTable();
        const { immLiquidations } = this.props;
        const immLiquidationsByOder = immLiquidations.get('byOrder');
        const sizeLiquidation = immLiquidationsByOder.size;
        const viewMoreButton = classNames(
            'extracts-list__view-more-button-row',
            {
                'extracts-list__view-more-button-row--invisible': sizeLiquidation <= this.state.maxRowsToSee
            }
        );

        return (
            <section className="liquidation-table">
                <OKTable>
                    {columnsTable}
                    <tbody>
                        {contentTable}
                    </tbody>
                </OKTable>
                <div className={viewMoreButton}>
                    <div className="extracts-list__view-more-button">
                        <OKButton
                            onClick={this.handleViewMoreButtonClick}
                            modifier="link-complementary"
                            size="small"
                        >
                            <FormattedText value="liquidation-viewMoreButton" />
                        </OKButton>
                    </div>
                </div>
            </section>
        );

    }
}

LiquidationTable.propTypes = {
    immLiquidations: PropTypes.object.isRequired
};

module.exports = LiquidationTable;
